<template>
  <v-app id="inspire">

    <v-navigation-drawer
      app
      temporary
      v-if="isLoggedIn"
      color="#EEEEEE"
      v-model="drawer"
      :clipped="$vuetify.breakpoint.lgAndUp"
    >
      <v-list dense>
        <v-list-item two-line v-if="isLoggedIn" class="mb-2">
          <v-list-item-avatar>
            <v-icon x-large>mdi-account</v-icon>
          </v-list-item-avatar>
          <v-list-item-content class="mt-6">
            <v-list-item-title class="font-weight-bold text-uppercase">{{ currentUser.nombre }}</v-list-item-title>
            <v-list-item-subtitle class="text-uppercase">Usario en Sesión</v-list-item-subtitle>
            <div align="right" class="mt-1">
              <v-btn x-small color="primary" dark to="/perfil">Mi perfil</v-btn>
            </div>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-group
          v-if="currentRole == 1 || currentRole == 2"
          prepend-icon="mdi-list"
        >
          <template v-slot:activator>
            <v-list-item-title class="ml-n11">CATÁLOGOS</v-list-item-title>
          </template>
          <v-list-item
            v-for="(menu, i) in adminCatalogo"
            :key="i"
            link
            :to="menu.link"
          >
            <v-list-item-title v-text="menu.text"></v-list-item-title>
          </v-list-item>
        </v-list-group>
        <v-divider class="mb-3"></v-divider>
        <v-list-group
          v-if="currentRole == 1 || currentRole == 3 || currentRole == 7 || currentRole == 8"
          prepend-icon="mdi-list"
        >
          <template v-slot:activator>
            <v-list-item-title class="ml-n11">PANEL</v-list-item-title>
          </template>
          <v-list-item v-if="currentRole == 7 || currentRole == 8" link to="/panel">
            <v-list-item-title>Escritos</v-list-item-title>
          </v-list-item>
          <v-list-item
            v-else
            v-for="(menu, i) in menuSolicitudes"
            :key="i"
            link
            :to="menu.link"
          >
            <v-list-item-title v-text="menu.text"></v-list-item-title>
          </v-list-item>
          <v-list-item v-if="currentRole == 1" link to="/escritos/panel">
            <v-list-item-title>Sentencias y Amparos</v-list-item-title>
          </v-list-item>
        </v-list-group>
        <v-list-group
          v-if="currentRole == 2 || currentRole == 4 || currentRole == 5 || currentRole == 6"
          prepend-icon="mdi-list"
        >
          <template v-slot:activator>
            <v-list-item-title class="ml-n11">PANEL</v-list-item-title>
          </template>
          <v-list-item v-if="currentRole == 2 || currentRole == 5" link to="/panel">
            <v-list-item-title>Escritos</v-list-item-title>
          </v-list-item>
          <v-list-item v-if="currentRole == 2" link to="/escritos/panel">
            <v-list-item-title>Sentencias y Amparos</v-list-item-title>
          </v-list-item>
          <v-list-item v-if="currentRole == 4 || currentRole == 6" link to="/escritos/panel">
            <v-list-item-title>Escritos</v-list-item-title>
          </v-list-item>
          <!-- <v-list-item
            v-else
            v-for="(menu, i) in menuListSolicitudes"
            :key="i"
            link
            :to="menu.link"
          >
            <v-list-item-title v-text="menu.text"></v-list-item-title>
          </v-list-item> -->
          <!-- <v-list-item v-if="!currentRole == 5 || !currentRole == 4" link to="/escritos/panel">
            <v-list-item-title>Sentencias y Amparos</v-list-item-title>
          </v-list-item> -->
        </v-list-group>
        <v-divider v-if="currentRole == 1 || currentRole == 4" class="mb-3"></v-divider>

        <!-- <v-list-group
          v-if="currentRole == 1 || currentRole == 4"
          prepend-icon="mdi-list"
        >
          <template v-slot:activator>
            <v-list-item-title class="ml-n11">PRESENTAR NUEVO</v-list-item-title>
          </template>
          <v-list-item link to="/sentencias/create">
            <v-list-item-title>Sentencias</v-list-item-title>
          </v-list-item>
          <v-list-item link to="/amparos/create">
            <v-list-item-title>Amparos</v-list-item-title>
          </v-list-item>
        </v-list-group>
        <v-divider class="mb-3"></v-divider> -->

        <v-list-group
          v-if="currentRole == 1 || currentRole == 2"
          prepend-icon="mdi-list"
        >
          <template v-slot:activator>
            <v-list-item-title class="ml-n11">ESTADÍSTICAS</v-list-item-title>
          </template>
          <v-list-item link to="/abogados">
            <v-list-item-title>Estadísticas Abogados</v-list-item-title>
          </v-list-item>
          <v-list-item link to="/estadistica">
            <v-list-item-title>Estadísticas Promociones</v-list-item-title>
          </v-list-item>
        </v-list-group>
        <!-- <v-divider class="mb-3"></v-divider> -->
      </v-list>
      <template v-slot:append>
        <div class="pa-2">
          <v-btn @click="logout" block color="grey darken-3 white--text">
            <v-icon>mdi-lock</v-icon> Salir</v-btn>
        </div>
      </template>
    </v-navigation-drawer>

    <img src="@/assets/BUZONWEB.svg" class="hidden-sm-and-down" style="width:100%;height:auto"/>
    <img src="@/assets/BUZONMOV.svg" class="hidden-md-and-up" style="width:100%;height:auto">
    <template>
      <v-card class="overflow-hidden">
        <v-app-bar
          :clipped-left="$vuetify.breakpoint.lgAndUp"
          dark
          dense
          color="#373736"
        >
          <v-app-bar-nav-icon
            v-if="isLoggedIn"
            @click.stop="drawer = !drawer"
          />
          <v-btn text href="/home">
            <img src="@/assets/logo_nuevo.png" style="width:30px;height:31px">
          </v-btn>
          <div v-if="isLoggedIn">
            <v-menu offset-y v-if="currentRole == 1 || currentRole == 2">
              <template v-slot:activator="{ on, attrs }">
                <v-btn dark v-bind="attrs" v-on="on" class="hidden-md-and-down ml-2">
                  CATÁLOGOS
                </v-btn>
              </template>
              <v-list>
                <v-list-item v-for="(menu, i) in adminCatalogo" :key="i" link :to="menu.link">
                  <v-list-item-title v-text="menu.text"></v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
            <v-menu offset-y v-if="currentRole == 1 || currentRole == 3 || currentRole == 7 || currentRole == 8">
              <template v-slot:activator="{ on, attrs }">
                <v-btn dark v-bind="attrs" v-on="on" class="hidden-sm-and-down ml-2">
                  PANEL
                </v-btn>
              </template>
              <v-list>
                <v-list-item v-if="currentRole == 7 || currentRole == 8" link to="/panel">
                  <v-list-item-title>Escritos</v-list-item-title>
                </v-list-item>
                <v-list-item v-else v-for="(item, i) in menuSolicitudes" :key="i" link :to="item.link">
                  <v-list-item-title>{{ item.text }}</v-list-item-title>
                </v-list-item>
                <v-list-item v-if="currentRole == 1" link to="/escritos/panel">
                  <v-list-item-title>Sentencias y Amparos</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
            <v-menu offset-y v-if="currentRole == 2 || currentRole == 4 || currentRole == 5 || currentRole == 6">
              <template v-slot:activator="{ on, attrs }">
                <v-btn dark v-bind="attrs" v-on="on" class="hidden-sm-and-down ml-2">
                  PANEL
                </v-btn>
              </template>
              <v-list>
                <v-list-item v-if="currentRole == 2 || currentRole == 5" link to="/panel">
                  <v-list-item-title>Escritos</v-list-item-title>
                </v-list-item>
                <!-- <v-list-item v-else v-for="(item, i) in menuListSolicitudes" :key="i" link :to="item.link">
                  <v-list-item-title>{{ item.text }}</v-list-item-title>
                </v-list-item> -->
                <v-list-item v-if="currentRole == 2" link to="/escritos/panel">
                  <v-list-item-title>Sentencias y Amparos</v-list-item-title>
                </v-list-item>
                <v-list-item v-if="currentRole == 4 || currentRole == 6" link to="/escritos/panel">
                  <v-list-item-title>Escritos</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn dark v-bind="attrs" href="https://www.youtube.com/watch?v=aHHZ3ingqsw" target="_blank" class="ml-2">
                  VIDEO TUTORIAL
                </v-btn>
              </template>
            </v-menu>
            <!-- <v-menu offset-y v-if="currentRole == 1 || currentRole == 4">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  dark
                  class="hidden-sm-and-down ml-2"
                  v-bind="attrs"
                  v-on="on">
                  PRESENTAR NUEVO
                </v-btn>
              </template>
              <v-list>
                <v-list-item link to="/sentencias/create">
                  <v-list-item-title>Sentencia</v-list-item-title>
                </v-list-item>
                <v-list-item link to="/amparos/create">
                  <v-list-item-title>Amparo</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu> -->
            <!-- <v-menu offset-y v-if="currentRole == 1">
              <template v-slot:activator="{ on, attrs }">
                <v-btn dark v-bind="attrs" to="/abogados" class="hidden-sm-and-down ml-2">
                  ESTADISTICA ABOGADOS
                </v-btn>
              </template>
            </v-menu> -->
              <v-menu offset-y v-if="currentRole == 1 || currentRole == 2">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    dark
                    class="hidden-sm-and-down ml-2"
                    v-bind="attrs"
                    v-on="on">
                    ESTADÍSTICAS
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item link to="/abogados">
                    <v-list-item-title>Estadísticas Abogados</v-list-item-title>
                  </v-list-item>
                  <v-list-item link to="/estadistica">
                    <v-list-item-title>Estadísticas Promociones</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
          </div>
          <v-spacer />
          <v-list color="#373736" v-if="isLoggedIn" class="text-button">
            <v-list-item-icon class="hidden-sm-and-down">
              <v-icon left>mdi-account</v-icon>
              {{ currentUser.nombre }}
            </v-list-item-icon>
          </v-list>
          <v-btn icon v-if="isLoggedIn" @click="logout">
            <v-icon>mdi-lock</v-icon>
          </v-btn>
        </v-app-bar>
      </v-card>
    </template>

    <v-main>
      <v-container fluid style="background-color:">
        <router-view></router-view>
      </v-container>
    </v-main>

    <v-footer padless color="#373736" dark>
      <v-col class="text-center" cols="12">
        {{ new Date().getFullYear() }} — <strong>STJ</strong>
      </v-col>
    </v-footer>

  </v-app>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    source: String
  },
  data: () => ({
    dialog: false,
    drawer: null,
    adminCatalogo: [
      { icon: "mdi-chevron-right", text: "Roles", link: "/roles" },
      { icon: "mdi-chevron-right", text: "Usuarios", link: "/users" },
      { icon: "mdi-chevron-right", text: "Salas", link: "/salas" },
      // { icon: "mdi-chevron-right", text: "Estadística Abogados", link: "/abogados" },
    ],
    menuSolicitudes: [
      { icon: "mdi-chevron-right", text: "Mi Panel", link: "/panel" },
      // { icon: "mdi-chevron-right", text: "Nueva Demanda Familiar", link: "/demandas/create" },
      { icon: "mdi-chevron-right", text: "Nueva Promoción", link: "/promociones/firma" },
    ],
    menuListSolicitudes: [
      { icon: "mdi-chevron-right", text: "Escritos", link: "/panel" },
    ],
    menuEstadisticas: [
      { icon: "mdi-chevron-right", text: "Estadísticas Abogados", link: "/abogados" },
      { icon: "mdi-chevron-right", text: "Estadísticas Promociones", link: "/estadistica" },
    ],
    // menuSecretarioAlza: [
    //   { icon: "mdi-chevron-right", text: "RESOLUCION DE APELACIÓN CATEO", link: "/panel-resoluciones/cateo" },
    // ],
    currentRole:''
  }),
  computed: {
    ...mapGetters(["roleUser", "isLoggedIn", "currentUser"])
  },
  mounted() {
    if (this.currentUser) {
      this.currentRole = this.currentUser.roles[0].id
    }
  },
  methods: {
    logout() {
      this.$store.dispatch("LOGOUT").then(() => {
          this.$swal({
            title: "Ha cerrado Sesión ",
            icon: "success",
            timer: 1000
          });
          window.location = "/"
          // this.$router.push("/");
        })
        .catch(error => {
          this.$swal({
            title: "Error",
            text: "No se pudo Cerrar la Sesión Correctamente",
            icon: "error",
            confirmButtonText: "Aceptar"
          });
        });
    }
  }
};
</script>
